<!--BASIC-->
<ng-container
  *ngIf="!_specialColumn.includes(this.column) && (!type || type === 'text') && showSort"
  [matColumnDef]="column"
>
  <th
    *matHeaderCellDef
    [disabled]="!canSort"
    [ngClass]="{
      'text-primary': isPredik,
      'text-wrap-cell': allowTextWrap
    }"
    [ngStyle]="cellStyle"
    mat-header-cell
    mat-sort-header
  >
    {{ label }}
  </th>

  <ng-container>
    <td
      (click)="clickRow(element)"
      *matCellDef="let element"
      [ngClass]="{
        'text-primary': isPredik,
        'text-wrap-cell': allowTextWrap
      }"
      [ngStyle]="cellStyle"
      [routerLink]="canSeeDetails ? routerLink(element) : null"
      mat-cell
    >
      <span [className]="'status-badge-' + (statusClassFunc ? statusClassFunc(element) : '')">
        {{ previousDisplay }}{{ customDisplay !== undefined ? customDisplay : display(element) }}{{ additionalDisplay }}
      </span>
      <ng-container *ngIf="indicatorFunc && indicatorFunc(element) as indicator">
        <mat-icon
          *ngIf="indicator.icon; else indicatorDot"
          class="status-icon"
          [ngStyle]="{ color: indicator.iconColor }"
          [matTooltip]="indicator.tooltip"
        >
          {{ indicator.icon }}
        </mat-icon>
        <ng-template #indicatorDot>
          <span [className]="'status-dot status-dot-' + indicator.color" [matTooltip]="indicator.tooltip"></span>
        </ng-template>
      </ng-container>
      <span *ngIf="customExtraHtml" [innerHTML]="element.customExtraHtml"></span>
    </td>
  </ng-container>
</ng-container>

<ng-container
  *ngIf="!_specialColumn.includes(this.column) && (!type || type === 'text') && !showSort"
  [matColumnDef]="column"
>
  <th
    *matHeaderCellDef
    [ngClass]="{
      'text-primary': isPredik,
      'text-wrap-cell': allowTextWrap
    }"
    [ngStyle]="cellStyle"
    mat-header-cell
  >
    {{ label }}
  </th>
  <ng-container>
    <td
      (click)="clickRow(element)"
      *matCellDef="let element"
      [ngClass]="{
        'text-primary': isPredik,
        'text-wrap-cell': allowTextWrap
      }"
      [ngStyle]="cellStyle"
      [routerLink]="canAccess() ? routerLink(element) : null"
      mat-cell
    >
      <span [className]="'status-badge-' + (statusClassFunc ? statusClassFunc(element) : '')">
        {{ previousDisplay }}{{ customDisplay !== undefined ? customDisplay : display(element) }}{{ additionalDisplay }}
      </span>
      <ng-container *ngIf="indicatorFunc && indicatorFunc(element) as indicator">
        <mat-icon
          *ngIf="indicator.icon; else indicatorDot"
          class="status-icon"
          [ngStyle]="{ color: indicator.iconColor }"
          [matTooltip]="indicator.tooltip"
        >
          {{ indicator.icon }}
        </mat-icon>
        <ng-template #indicatorDot>
          <span [className]="'status-dot status-dot-' + indicator.color" [matTooltip]="indicator.tooltip"></span>
        </ng-template>
      </ng-container>
    </td>
  </ng-container>
</ng-container>

<!-- Checkbox Column -->
<ng-container *ngIf="column === 'selection'" matColumnDef="selection">
  <th *matHeaderCellDef mat-header-cell>
    <mat-checkbox
      *ngIf="canSelectCheckBoxRows"
      (change)="$event ? toggleAllRows() : null"
      [checked]="selection.hasValue() && isAllSelected()"
      [disabled]="selectAllDisabled"
      [indeterminate]="selection.hasValue() && !isAllSelected()"
      [matTooltip]="checkboxTooltip"
    ></mat-checkbox>
    {{ additionalDisplay }}
  </th>
  <ng-container>
    <td *matCellDef="let element" mat-cell>
      <mat-checkbox
        *ngIf="canSelectCheckBoxRows"
        (change)="toggleRow($event, element)"
        (click)="$event.stopPropagation()"
        [checked]="selection.isSelected(element)"
        [disabled]="element.dataTableSelectDisabled || element.isActive === false"
      ></mat-checkbox>
    </td>
  </ng-container>
</ng-container>

<!-- Favorite Column -->

<ng-container *ngIf="column === 'favorite'" matColumnDef="favorite">
  <th *matHeaderCellDef [disabled]="!canSort" [ngClass]="{ 'text-primary': isPredik }" mat-header-cell mat-sort-header>
    {{ label }}
  </th>
  <td *matCellDef="let element" mat-cell>
    <button mat-icon-button (click)="toggleFavorite(element)" [disabled]="!canFavorite">
      <mat-icon *ngIf="isFavorite(element)">star</mat-icon>
      <mat-icon *ngIf="!isFavorite(element)">star_border</mat-icon>
    </button>
  </td>
</ng-container>

<ng-container *ngIf="type === 'favorite'" matColumnDef="favorite">
  <th *matHeaderCellDef [disabled]="!canSort" [ngClass]="{ 'text-primary': isPredik }" mat-header-cell mat-sort-header>
    {{ label }}
  </th>
  <td *matCellDef="let element" mat-cell>
    <button mat-icon-button (click)="toggleFavorite(element)" [disabled]="!canFavorite">
      <mat-icon *ngIf="isFavorite(element)">star</mat-icon>
      <mat-icon *ngIf="!isFavorite(element)">star_border</mat-icon>
    </button>
  </td>
</ng-container>

<ng-container *ngIf="type === 'bubble'" matColumnDef="bubble">
  <th *matHeaderCellDef [disabled]="!canSort" [ngClass]="{ 'text-primary': isPredik }" mat-header-cell mat-sort-header>
    {{ label }}
  </th>
  <td *matCellDef="let element" mat-cell>
    <div [className]="'status-badge-' + statusClassFunc(element)">vide</div>
  </td>
</ng-container>

<!--NUMBER-->
<ng-container *ngIf="type == 'number' && showSort" [matColumnDef]="column">
  <th
    *matHeaderCellDef
    [disabled]="!canSort"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    mat-header-cell
    mat-sort-header
    class="text-right"
  >
    {{ label }}
  </th>
  <ng-container>
    <td
      (click)="clickRow(element)"
      *matCellDef="let element"
      [ngClass]="{ 'text-primary': isPredik }"
      [ngStyle]="cellStyle"
      class="text-right"
      [routerLink]="canAccess() ? routerLink(element) : null"
      mat-cell
    >
      {{ previousDisplay }}
      {{
        customDisplay !== undefined
          ? customDisplay
          : isNumber(display(element))
            ? (display(element) | number: '1.' + maxDecimal + '-' + maxDecimal)
            : display(element)
      }}
      <!--        {{ (round(display(element)) || round(display(element)) === 0) || customDisplay !== undefined ? '' : '-' | number : '1.' + maxDecimal + '-' + maxDecimal }}-->
      {{ additionalDisplay }}
    </td>
  </ng-container>
</ng-container>

<!-- CUSTOM -->
<ng-container *ngIf="type == 'number' && !showSort" [matColumnDef]="column">
  <th
    *matHeaderCellDef
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    mat-header-cell
    class="text-right"
  >
    {{ label }}
  </th>
  <td
    (click)="clickRow(element)"
    *matCellDef="let element"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    class="text-right"
    [routerLink]="canAccess() ? routerLink(element) : null"
    mat-cell
  >
    {{ previousDisplay }}
    {{
      customDisplay !== undefined
        ? customDisplay
        : isNumber(display(element))
          ? (display(element) | number: '1.' + maxDecimal + '-' + maxDecimal)
          : display(element)
    }}
    <!--        {{ (round(display(element)) || round(display(element)) === 0) || customDisplay !== undefined ? '' : '-' | number : '1.' + maxDecimal + '-' + maxDecimal }}-->
    {{ additionalDisplay }}
  </td>
</ng-container>

<!--DATE-->
<ng-container *ngIf="type == 'date' && showSort" [matColumnDef]="column">
  <th
    *matHeaderCellDef
    [disabled]="!canSort"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    mat-header-cell
    mat-sort-header
  >
    {{ label }}
  </th>
  <td
    (click)="clickRow(element)"
    *matCellDef="let element"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    [routerLink]="canAccess() ? routerLink(element) : null"
    mat-cell
  >
    <ng-container *ngIf="display(element) === '-'; else dateBlock">
      {{ previousDisplay }}-{{ additionalDisplay }}
    </ng-container>
    <ng-template #dateBlock>
      <span [className]="'status-badge-' + (statusClassFunc ? statusClassFunc(element) : '')">
        {{ previousDisplay }}{{ display(element) | date: dateFormat }}{{ additionalDisplay }}
      </span>
    </ng-template>
  </td>
</ng-container>

<ng-container *ngIf="type == 'date' && !showSort" [matColumnDef]="column">
  <th *matHeaderCellDef [ngClass]="{ 'text-primary': isPredik }" [ngStyle]="cellStyle" mat-header-cell>{{ label }}</th>
  <td
    (click)="clickRow(element)"
    *matCellDef="let element"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    [routerLink]="canAccess() ? routerLink(element) : null"
    mat-cell
  >
    <ng-container *ngIf="display(element) === '-'; else dateBlock">
      {{ previousDisplay }}-{{ additionalDisplay }}
    </ng-container>
    <ng-template #dateBlock>
      {{ previousDisplay }}{{ display(element) | date: dateFormat }}{{ additionalDisplay }}
    </ng-template>
  </td>
</ng-container>

<!--DATETIME-->
<ng-container *ngIf="type == 'dateTime' && showSort" [matColumnDef]="column">
  <th
    *matHeaderCellDef
    [disabled]="!canSort"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    mat-header-cell
    mat-sort-header
  >
    {{ label }}
  </th>
  <td
    (click)="clickRow(element)"
    *matCellDef="let element"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    [routerLink]="canAccess() ? routerLink(element) : null"
    mat-cell
  >
    <ng-container *ngIf="display(element) === '-'; else dateBlock">
      {{ previousDisplay }}-{{ additionalDisplay }}
    </ng-container>
    <ng-template #dateBlock>
      {{ previousDisplay }}{{ display(element) | date: dateTimeFormat }}{{ additionalDisplay }}
    </ng-template>
  </td>
</ng-container>

<ng-container *ngIf="type == 'dateTime' && !showSort" [matColumnDef]="column">
  <th *matHeaderCellDef [ngClass]="{ 'text-primary': isPredik }" [ngStyle]="cellStyle" mat-header-cell>{{ label }}</th>
  <td
    (click)="clickRow(element)"
    *matCellDef="let element"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    mat-cell
  >
    <ng-container *ngIf="display(element) === '-'; else dateBlock">
      {{ previousDisplay }}-{{ additionalDisplay }}
    </ng-container>
    <ng-template #dateBlock>
      {{ previousDisplay }}{{ display(element) | date: dateTimeFormat }}{{ additionalDisplay }}
    </ng-template>
  </td>
</ng-container>

<!--ÉTAT E-SHOP : booléen (identique au type boolean) + tooltip détaillé suspension/disponibilité/quota - PRED-3195-->
<ng-container *ngIf="type === 'eshopStatus' && showSort" [matColumnDef]="column">
  <th
    *matHeaderCellDef
    [disabled]="!canSort"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    mat-header-cell
    mat-sort-header
  >
    {{ label }}
  </th>
  <td
    (click)="clickRow(element)"
    *matCellDef="let element"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    [routerLink]="canAccess() ? routerLink(element) : null"
    mat-cell
  >
    <a
      *ngIf="eshopVisible(element)"
      class="w-8 h-8 leading-none flex items-center justify-center text-primary bg-primary-light"
      mat-icon-button
      matTooltipClass="matooltip"
      [matTooltip]="eshopStatusTooltip(element)"
    >
      <mat-icon [icIcon]="icDone" size="18px"></mat-icon>
    </a>
    <a
      *ngIf="!eshopVisible(element)"
      class="w-8 h-8 leading-none flex items-center justify-center text-accent bg-accent-light"
      mat-icon-button
      matTooltipClass="matooltip"
      [matTooltip]="eshopStatusTooltip(element)"
    >
      <mat-icon [icIcon]="icClose" size="18px"></mat-icon>
    </a>
  </td>
</ng-container>

<ng-container *ngIf="type === 'eshopStatus' && !showSort" [matColumnDef]="column">
  <th *matHeaderCellDef [ngClass]="{ 'text-primary': isPredik }" [ngStyle]="cellStyle" mat-header-cell>
    {{ label }}
  </th>
  <td
    (click)="clickRow(element)"
    *matCellDef="let element"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    [routerLink]="canAccess() ? routerLink(element) : null"
    mat-cell
  >
    <a
      *ngIf="eshopVisible(element)"
      class="w-8 h-8 leading-none flex items-center justify-center text-primary bg-primary-light"
      mat-icon-button
      matTooltipClass="matooltip"
      [matTooltip]="eshopStatusTooltip(element)"
    >
      <mat-icon [icIcon]="icDone" size="18px"></mat-icon>
    </a>
    <a
      *ngIf="!eshopVisible(element)"
      class="w-8 h-8 leading-none flex items-center justify-center text-accent bg-accent-light"
      mat-icon-button
      matTooltipClass="matooltip"
      [matTooltip]="eshopStatusTooltip(element)"
    >
      <mat-icon [icIcon]="icClose" size="18px"></mat-icon>
    </a>
  </td>
</ng-container>

<!--BOOLEAN-->
<ng-container *ngIf="type === 'boolean' && showSort" [matColumnDef]="column">
  <th
    *matHeaderCellDef
    [disabled]="!canSort"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    mat-header-cell
    mat-sort-header
  >
    {{ label }}
  </th>
  <td
    (click)="clickRow(element)"
    *matCellDef="let element"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    [routerLink]="canAccess() ? routerLink(element) : null"
    mat-cell
  >
    <a
      (click)="$event.stopPropagation(); onValueChange.emit({ column, element })"
      *ngIf="elementIsTrue(element)"
      class="w-8 h-8 leading-none flex items-center justify-center hover:bg-hover text-primary bg-primary-light"
      mat-icon-button
    >
      <mat-icon [icIcon]="icDone" size="18px"></mat-icon>
    </a>
    <a
      (click)="$event.stopPropagation(); onValueChange.emit({ column, element })"
      *ngIf="!elementIsTrue(element)"
      class="w-8 h-8 leading-none flex items-center justify-center hover:bg-hover text-accent bg-accent-light"
      mat-icon-button
    >
      <mat-icon [icIcon]="icClose" size="18px"></mat-icon>
    </a>
  </td>
</ng-container>

<ng-container *ngIf="type === 'boolean' && !showSort" [matColumnDef]="column">
  <th *matHeaderCellDef [ngClass]="{ 'text-primary': isPredik }" [ngStyle]="cellStyle" mat-header-cell>
    {{ label }}
  </th>
  <td
    (click)="clickRow(element)"
    *matCellDef="let element"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    [routerLink]="canAccess() ? routerLink(element) : null"
    mat-cell
  >
    <a
      (click)="$event.stopPropagation(); onValueChange.emit(element[column])"
      *ngIf="element[column]"
      class="w-8 h-8 leading-none flex items-center justify-center hover:bg-hover text-primary bg-primary-light"
      mat-icon-button
    >
      <mat-icon [icIcon]="icDone" size="18px"></mat-icon>
    </a>
    <a
      (click)="$event.stopPropagation(); onValueChange.emit(element[column])"
      *ngIf="!element[column]"
      class="w-8 h-8 leading-none flex items-center justify-center hover:bg-hover text-accent bg-accent-light"
      mat-icon-button
    >
      <mat-icon [icIcon]="icClose" size="18px"></mat-icon>
    </a>
  </td>
</ng-container>

<ng-container *ngIf="type === 'isSpecialConditions' && showSort" [matColumnDef]="column">
  <th
    *matHeaderCellDef
    [disabled]="!canSort"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    mat-header-cell
    mat-sort-header
  >
    {{ label }}
  </th>
  <td
    (click)="clickRow(element)"
    *matCellDef="let element"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    [routerLink]="canAccess() ? routerLink(element) : null"
    mat-cell
  >
    <a
      (click)="$event.stopPropagation(); onValueChange.emit({ column, element })"
      *ngIf="elementIsNotNull(element)"
      class="w-8 h-8 leading-none flex items-center justify-center hover:bg-hover text-primary bg-primary-light"
      mat-icon-button
    >
      <mat-icon [icIcon]="icDone" size="18px"></mat-icon>
    </a>
    <a
      (click)="$event.stopPropagation(); onValueChange.emit({ column, element })"
      *ngIf="!elementIsNotNull(element)"
      class="w-8 h-8 leading-none flex items-center justify-center hover:bg-hover text-accent bg-accent-light"
      mat-icon-button
    >
      <mat-icon [icIcon]="icClose" size="18px"></mat-icon>
    </a>
  </td>
</ng-container>

<!--IS ACTIVE-->
<ng-container *ngIf="column === 'isActive' && showSort" matColumnDef="isActive">
  <th *matHeaderCellDef [disabled]="!canSort" [ngClass]="{ 'text-primary': isPredik }" mat-header-cell mat-sort-header>
    Is Active
  </th>
  <td
    *matCellDef="let element"
    [ngClass]="{ 'text-primary': isPredik }"
    [routerLink]="canAccess() ? routerLink(element) : null"
    mat-cell
  >
    <a
      (click)="$event.stopPropagation()"
      *ngIf="element.isActive"
      class="w-8 h-8 leading-none flex items-center justify-center hover:bg-hover text-primary bg-primary-light"
      mat-icon-button
    >
      <mat-icon [icIcon]="icDone" size="18px"></mat-icon>
    </a>
    <a
      (click)="$event.stopPropagation()"
      *ngIf="!element.isActive"
      class="w-8 h-8 leading-none flex items-center justify-center hover:bg-hover text-accent bg-accent-light"
      mat-icon-button
    >
      <mat-icon [icIcon]="icClose" size="18px"></mat-icon>
    </a>
  </td>
</ng-container>

<ng-container *ngIf="column === 'isActive' && !showSort" matColumnDef="isActive">
  <th *matHeaderCellDef [disabled]="!canSort" [ngClass]="{ 'text-primary': isPredik }" mat-sort-header mat-header-cell>
    Is Active
  </th>
  <td
    *matCellDef="let element"
    [ngClass]="{ 'text-primary': isPredik }"
    [routerLink]="canAccess() ? routerLink(element) : null"
    mat-cell
  >
    <a
      (click)="$event.stopPropagation()"
      *ngIf="element.isActive"
      class="w-8 h-8 leading-none flex items-center justify-center hover:bg-hover text-primary bg-primary-light"
      mat-icon-button
    >
      <mat-icon [icIcon]="icDone" size="18px"></mat-icon>
    </a>
    <a
      (click)="$event.stopPropagation()"
      *ngIf="!element.isActive"
      class="w-8 h-8 leading-none flex items-center justify-center hover:bg-hover text-accent bg-accent-light"
      mat-icon-button
    >
      <mat-icon [icIcon]="icClose" size="18px"></mat-icon>
    </a>
  </td>
</ng-container>

<!--CATEGORY-->
<ng-container
  *ngIf="!_specialColumn.includes(this.column) && (!type || type === 'category') && showSort"
  [matColumnDef]="column"
>
  <th
    *matHeaderCellDef
    [disabled]="!canSort"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    mat-header-cell
    mat-sort-header
  >
    {{ label }}
  </th>
  <td
    (click)="clickRow(element)"
    *matCellDef="let element"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    [routerLink]="canAccess() ? routerLink(element) : null"
    mat-cell
  >
    {{ display(element) }}{{ additionalDisplay }}
  </td>
</ng-container>

<ng-container
  *ngIf="!_specialColumn.includes(this.column) && (!type || type === 'category') && !showSort"
  [matColumnDef]="column"
>
  <th *matHeaderCellDef [ngClass]="{ 'text-primary': isPredik }" [ngStyle]="cellStyle" mat-header-cell>{{ label }}</th>
  <td
    (click)="clickRow(element)"
    *matCellDef="let element"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    [routerLink]="canAccess() ? routerLink(element) : null"
    mat-cell
  >
    {{ display(element) }}{{ additionalDisplay }}
  </td>
</ng-container>

<!--TECHNICAL IDENTIFIER-->
<ng-container
  *ngIf="!_specialColumn.includes(this.column) && (!type || type === 'technicalIdentifier') && showSort"
  [matColumnDef]="column"
>
  <th
    *matHeaderCellDef
    [disabled]="!canSort"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    mat-header-cell
    mat-sort-header
  >
    {{ label }}
  </th>
  <td
    (click)="clickRow(element, $event)"
    *matCellDef="let element"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    [routerLink]="canAccess() ? routerLink(element) : null"
    mat-cell
  >
    <div class="flex flex-row justify-between items-center">
      {{ display(element) }}{{ additionalDisplay }}
      <mat-icon [icIcon]="icBaselineContentCopy" class="ml-1 text-gray" width="16"></mat-icon>
    </div>
  </td>
</ng-container>

<ng-container
  *ngIf="!_specialColumn.includes(this.column) && (!type || type === 'technicalIdentifier') && !showSort"
  [matColumnDef]="column"
>
  <th *matHeaderCellDef [ngClass]="{ 'text-primary': isPredik }" [ngStyle]="cellStyle" mat-header-cell>{{ label }}</th>
  <td
    (click)="clickRow(element)"
    *matCellDef="let element"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    [routerLink]="canAccess() ? routerLink(element) : null"
    mat-cell
  >
    {{ display(element) }}{{ additionalDisplay }}
    <mat-icon [icIcon]="icBaselineContentCopy"></mat-icon>
  </td>
</ng-container>

<!--CATALOGUE-->
<ng-container
  *ngIf="!_specialColumn.includes(this.column) && (!type || type === 'catalogue') && showSort"
  [matColumnDef]="column"
>
  <th
    *matHeaderCellDef
    [disabled]="!canSort"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    mat-header-cell
    mat-sort-header
  >
    {{ label }}
  </th>
  <td
    (click)="clickRow(element, $event)"
    *matCellDef="let element"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    [routerLink]="canAccess() ? routerLink(element) : null"
    mat-cell
  >
    <div class="flex flex-row justify-between items-center">
      <ng-container
        *ngIf="status === 'enabled' && element.quantity !== '-' && !element.cannotUpdateQuantity; else disableValueSort"
      >
        <mat-icon
          (click)="catalogueChange('remove', element)"
          [icIcon]="icRemove"
          class="ml-1 text-gray"
          width="16"
        ></mat-icon>
        <mat-form-field class="w-14 text-center">
          <input
            (change)="catalogueChange('update', element, $event)"
            [value]="element.quantity"
            matInput
            min="0"
            type="number"
          />
        </mat-form-field>
        <mat-icon
          (click)="catalogueChange('add', element)"
          [icIcon]="icAdd"
          class="ml-1 text-gray"
          width="16"
        ></mat-icon>
      </ng-container>
      <ng-template #disableValueSort>
        {{ element.quantity }}
      </ng-template>
    </div>
  </td>
</ng-container>

<ng-container
  *ngIf="!_specialColumn.includes(this.column) && (!type || type === 'catalogue') && !showSort"
  [matColumnDef]="column"
>
  <th *matHeaderCellDef [ngClass]="{ 'text-primary': isPredik }" [ngStyle]="cellStyle" mat-header-cell>{{ label }}</th>
  <td
    (click)="clickRow(element)"
    *matCellDef="let element"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    [routerLink]="canAccess() ? routerLink(element) : null"
    mat-cell
  >
    <ng-container
      *ngIf="status === 'enabled' && element.quantity !== '-' && !element.cannotUpdateQuantity; else disableValueNoSort"
    >
      <mat-icon
        (click)="catalogueChange('remove', element)"
        [icIcon]="icRemove"
        class="ml-1 text-gray"
        width="16"
      ></mat-icon>
      <mat-form-field class="w-14 text-center">
        <input
          (change)="catalogueChange('update', element, $event)"
          [value]="element.quantity"
          matInput
          min="0"
          type="number"
        />
      </mat-form-field>
      <mat-icon (click)="catalogueChange('add', element)" [icIcon]="icAdd" class="ml-1 text-gray" width="16"></mat-icon>
    </ng-container>
    <ng-template #disableValueNoSort>
      {{ element.quantity }}
    </ng-template>
  </td>
</ng-container>

<!--NOTIFICATION STATUS-->
<ng-container
  *ngIf="!_specialColumn.includes(this.column) && (!type || type === 'notificationStatus')"
  [matColumnDef]="column"
  class="w-1"
>
  <th *matHeaderCellDef [ngClass]="{ 'text-primary': isPredik }" mat-header-cell mat-sort-header>{{ label }}</th>
  <td
    (click)="clickRow(element)"
    *matCellDef="let element"
    [ngClass]="{ 'text-primary': isPredik }"
    [routerLink]="canAccess() ? routerLink(element) : null"
    mat-cell
  >
    <div *ngIf="element.status === _notificationStatus.UN_READ" class="rounded-full bg-primary w-4 h-4"></div>
  </td>
</ng-container>

<!--attentionRequiered -->
<ng-container
  *ngIf="!_specialColumn.includes(this.column) && (!type || type === 'attentionRequiered')"
  [matColumnDef]="column"
  class="w-1"
>
  <th *matHeaderCellDef [ngClass]="{ 'text-primary': isPredik }" mat-header-cell mat-sort-header>{{ label }}</th>
  <td
    (click)="clickRow(element)"
    *matCellDef="let element"
    [ngClass]="{ 'text-primary': isPredik }"
    [routerLink]="canAccess() ? routerLink(element) : null"
    mat-cell
  >
    <div
      *ngIf="element.isAttentionRequired"
      [matTooltip]="attentionRequieredTooltip || element.attentionRequieredTooltip"
      class="rounded-full bg-primary w-4 h-4"
    ></div>
  </td>
</ng-container>

<!--ACTION-->
<ng-container *ngIf="column === 'actions'" matColumnDef="actions">
  <th *matHeaderCellDef [ngClass]="{ 'text-primary': isPredik }" mat-header-cell>{{ label }}</th>
  <td *matCellDef="let element" [ngClass]="{ 'text-primary': isPredik }" class="w-10" mat-cell>
    <div *ngIf="!element.noAction" style="text-align: right">
      <div>
        <span
          *ngIf="
            (isProductPrestation && element?.contract?.status === 'EXPIRED') ||
            element?.contract?.status === 'SUSPENDED'
          "
        >
          {{ actionText }}
        </span>

        <div
          *ngIf="
            (isProductPrestation &&
              element?.contract?.status != 'EXPIRED' &&
              element?.contract?.status != 'SUSPENDED') ||
            !isProductPrestation
          "
        >
          <button
            *ngIf="
              canDelete && !element.isNotDeletable && (canDeleteDynamically ? canDeleteDynamically(element) : true)
            "
            (click)="$event.stopPropagation(); deleteItem(element)"
            class="text-red"
            mat-icon-button
          >
            <mat-icon [icIcon]="icDelete"></mat-icon>
          </button>

          <span
            *ngIf="
              (canUpdateDynamically ? canUpdateDynamically(element) : true) &&
              (showActionDynamically ? showActionDynamically(element) : true)
            "
          >
            <button
              *ngIf="canArchive || canUpdate || canDownload || showAction || canDuplicate || canSuspend"
              (click)="$event.stopPropagation(); selectItem(element)"
              [matMenuTriggerData]="{ element: element }"
              [matMenuTriggerFor]="columnActionMenu"
              mat-icon-button
              type="button"
            >
              <mat-icon [icIcon]="icMoreVert" [matTooltipShowDelay]="1500" matTooltip="actions"></mat-icon>
            </button>
          </span>
        </div>
      </div>
    </div>
  </td>
</ng-container>
<mat-menu #columnActionMenu="matMenu" xPosition="before" yPosition="below">
  <ng-template let-element="element" matMenuContent>
    <ng-container *ngTemplateOutlet="actionsTemplate; context: { value: _selectedItem }"></ng-container>
    <!--        <button (click)="favoriteItem()" *ngIf='canFavorite && !canArchive && !element.isNotDeletable'-->
    <!--                class="mat-menu-item">-->
    <!--            <mat-icon [icIcon]="icStar"></mat-icon>-->
    <!--            Assigner favoris-->
    <!--        </button>-->

    <button
      (click)="changeReadStatus(element)"
      *ngIf="canChangeStatus && !canArchive && !element.isNotDeletable"
      class="mat-menu-item"
    >
      <mat-icon [icIcon]="icEdit"></mat-icon>
      {{ element.status === 'Lu' ? 'Marquer comme Non lu' : 'Marquer comme Lu' }}
    </button>

    <button
      (click)="updateItem()"
      *ngIf="canUpdate && (canUpdateDynamically ? canUpdateDynamically(element) : true)"
      class="mat-menu-item"
    >
      <mat-icon [icIcon]="icEdit"></mat-icon>
      Modifier
    </button>

    <button (click)="downloadItem(element)" *ngIf="canDownload" class="mat-menu-item">
      <mat-icon>file_download</mat-icon>
      Télécharger
    </button>

    <button (click)="duplicateItem()" *ngIf="canDuplicate" class="mat-menu-item">
      <mat-icon [icIcon]="icDuplicate"></mat-icon>
      Dupliquer
    </button>

    <!--        the delete button has become a trash icon (PRED-1885)-->
    <!--        <button (click)="deleteItem()" *ngIf='canDelete && !canArchive && !element.isNotDeletable'-->
    <!--                class="mat-menu-item">-->
    <!--            <mat-icon [icIcon]="icDelete"></mat-icon>-->
    <!--            Supprimer-->
    <!--        </button>-->

    <!--        <button (click)="deleteItem()" *ngIf='canDelete && !canArchive && !element.isNotDeletable'-->
    <!--                class="mat-menu-item">-->
    <!--            <mat-icon [icIcon]="icDelete"></mat-icon>-->
    <!--            Supprimer-->
    <!--        </button>-->
    <button (click)="archiveItem()" *ngIf="canArchive && !element.isNotArchivable" class="mat-menu-item">
      <mat-icon [icIcon]="icArchive"></mat-icon>
      {{ element.isArchive ? 'Désarchiver' : 'Archiver' }}
    </button>

    <button (click)="suspendItem()" *ngIf="canSuspend && !element.isNotArchivable" class="mat-menu-item">
      <mat-icon>pause</mat-icon>
      {{ element.isSuspended ? 'Réactiver' : 'Suspendre' }}
    </button>

    <!--        <button *ngIf='canDuplicate' (click)="duplicateItem()" class="mat-menu-item">-->
    <!--            <mat-icon>collections</mat-icon>-->
    <!--            Dupliquer-->
    <!--        </button>-->
    <!--    <button class="mat-menu-item" (click)="deleteItem()">-->
    <!--        <mat-icon [icIcon]="icDelete"></mat-icon>-->
    <!--        Switch isActive-->
    <!--    </button>-->
  </ng-template>
</mat-menu>

<!--TYPE CUSTOM-->

<ng-container *ngIf="(!type || type === 'custom') && showSort" [matColumnDef]="column">
  <th
    *matHeaderCellDef
    [disabled]="!canSort"
    [ngClass]="{ 'text-primary': isPredik }"
    [ngStyle]="cellStyle"
    mat-sort-header
    mat-header-cell
  >
    <div *ngIf="customColHeader">
      <ng-container *ngTemplateOutlet="customColumnHeaderTemplate; context: { $implicit: column }"></ng-container>
    </div>
    <div *ngIf="!customColHeader">
      {{ label }}
    </div>
  </th>
  <ng-container>
    <td
      (click)="clickRow(element)"
      *matCellDef="let element"
      [ngClass]="{ 'text-primary': isPredik }"
      [ngStyle]="cellStyle"
      class="text-secondary"
      mat-cell
    >
      <ng-container
        *ngTemplateOutlet="customColumnTemplate; context: { $implicit: column, element: element, status: status }"
      ></ng-container>
    </td>
  </ng-container>
</ng-container>

<ng-container *ngIf="(!type || type === 'custom') && !showSort" [matColumnDef]="column">
  <th *matHeaderCellDef [ngClass]="{ 'text-primary': isPredik }" [ngStyle]="cellStyle" mat-header-cell>
    <div *ngIf="customColHeader">
      <ng-container *ngTemplateOutlet="customColumnHeaderTemplate; context: { $implicit: column }"></ng-container>
    </div>
    <div *ngIf="!customColHeader">
      {{ label }}
    </div>
  </th>
  <ng-container>
    <td
      (click)="clickRow(element)"
      *matCellDef="let element"
      [ngClass]="{ 'text-primary': isPredik }"
      [ngStyle]="cellStyle"
      class="w-10 text-secondary"
      mat-cell
    >
      <ng-container
        *ngTemplateOutlet="customColumnTemplate; context: { $implicit: column, element: element, status: status }"
      ></ng-container>
    </td>
  </ng-container>
</ng-container>
